<script setup lang="ts">
import { NxtIcon } from '@future-harry/nxt-styles';

const props = defineProps({
   data: {
      type: Object,
      default: () => ({}),
   },
});
</script>

<template>
   <div class="video-content">
      <video v-if="props.data.video?.url" :src="props.data.video.url" controls />
      <div v-else class="video-content__placeholder">
         <NxtIcon name="play" size="large" />
      </div>
   </div>
</template>

<style scoped lang="scss">
.video-content {
   display: flex;
   margin: 0 auto;
   max-width: 1000px;
   align-items: center;
   text-align: center;
   width: 100%;

   video {
      width: 100%;
      height: 100%;
   }

   &__placeholder {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: var(--nxt-light-grey);
      min-height: 200px;
   }
}
</style>
